import { LitElement, html, Splide } from '@hh/global.js'

export class HHCollectionProductListing extends LitElement {
  static properties = {
    slider: { state: true },
  }

  constructor() {
    super()
    this.maxProducts = this.dataset.maxProducts || 12
  }

  connectedCallback() {
    super.connectedCallback()
    const slider = this.querySelector('.splide')

    if (slider) {
      this.initSlider(slider)
    }
  }

  initSlider(slider) {
    this.slider = new Splide(slider, {
      type: 'slide',
      arrows: false,
      autoplay: false,
      autoWidth: true,
      gap: '0.8rem',
      direction: 'rtl',
      start: this.maxProducts,
    })

    this.slider.mount()
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('collection-product-listing', HHCollectionProductListing)
